import { useTranslation } from "react-i18next";

export default function TaglineSection() {
  const { t } = useTranslation();

  return (
    <section id="tagline" className="relative py-36 px-8 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/c8b290829352aa3d4ad27497d2e14094.jpg"
          alt="Healthcare background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-[#0F1A14]/65" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <div
          className="inline-block text-[11px] tracking-[0.25em] uppercase text-white/60 font-medium mb-10 border border-white/20 px-5 py-2 rounded-full"
          style={{ fontFamily: "'DM Sans', sans-serif" }}
        >
          {t("tagline.badge")}
        </div>

        <blockquote
          className="text-5xl md:text-6xl font-light text-white leading-tight mb-10"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          {t("tagline.quote1")}<br />
          <em className="italic">{t("tagline.quote2")}</em>
        </blockquote>

        <p
          className="text-white/65 text-[15px] leading-relaxed max-w-lg mx-auto font-light"
          style={{ fontFamily: "'DM Sans', sans-serif" }}
        >
          {t("tagline.description")}
        </p>

        <div className="mt-14 flex items-center justify-center gap-6">
          <div className="flex flex-col items-center">
            <span
              className="text-4xl font-light text-white mb-1"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              {t("tagline.quality")}
            </span>
            <span
              className="text-[11px] tracking-[0.2em] uppercase text-white/50 font-medium"
              style={{ fontFamily: "'DM Sans', sans-serif" }}
            >
              {t("tagline.qualitySub")}
            </span>
          </div>
          <div className="w-px h-12 bg-white/20" />
          <div className="flex flex-col items-center">
            <span
              className="text-4xl font-light text-white mb-1"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              {t("tagline.accessible")}
            </span>
            <span
              className="text-[11px] tracking-[0.2em] uppercase text-white/50 font-medium"
              style={{ fontFamily: "'DM Sans', sans-serif" }}
            >
              {t("tagline.accessibleSub")}
            </span>
          </div>
          <div className="w-px h-12 bg-white/20" />
          <div className="flex flex-col items-center">
            <span
              className="text-4xl font-light text-white mb-1"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              {t("tagline.human")}
            </span>
            <span
              className="text-[11px] tracking-[0.2em] uppercase text-white/50 font-medium"
              style={{ fontFamily: "'DM Sans', sans-serif" }}
            >
              {t("tagline.humanSub")}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
